const HIGHEST = 0;
const HIGH = 1;
const MIDDLE = 2;
const LOW = Infinity;

/**
 * Enums associated with the labeler
 * @readonly
 * @enum {object}
 */
export default Object.freeze({
	labelPriorities: {
		LOW,
		MARKET_OPEN: HIGH,
		MARKET_CLOSE: HIGH,
		MIDDAY: MIDDLE,
		MIDDLE,
		HIGH,
		HIGHEST
	}
});
